import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dialogTitleAdmin: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.dialog-title-admin',
		defaultMessage:
			"We've added a {bold_space_name} filter to help you find and manage your articles. Head to your settings page to link more spaces to your knowledge base.",
		description: 'Title which explains that knowledge base is powered by Confluence',
	},
	dialogTitleAgent: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.dialog-title-agent',
		defaultMessage:
			"We've added a {bold_space_name} filter to help you manage your knowledge base articles across multiple Confluence spaces.",
		description: 'Title which explains that knowledge base is powered by Confluence',
	},
	linkedSpacesText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.linked-spaces-text',
		defaultMessage: 'linked spaces',
		description: 'Title which explains that knowledge base is powered by Confluence',
	},
	buttonText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.button-text',
		defaultMessage: 'Ok',
		description: 'The button that user clicks to stop the changeboarding',
	},
	settingsUrlText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.settings-url-text',
		defaultMessage: 'Go to settings',
		description: 'The text for the admin to link to settings page',
	},
});
